import { client } from '../../..'
import { REVIEWERS_OF_BU, REVIEWERS_OF_COMPANY } from '../Queries'
import { CREATE_REVIEWER_OF_EMPLOYEE_RELATION, DELETE_REVIEWER_OF_EMPLOYEE_RELATION } from '../Mutations'
import {
  CreateReviewerOfEmployeeMutation,
  CreateReviewerOfEmployeeMutationVariables,
  DeleteReviewerOfEmployeeMutation,
  DeleteReviewerOfEmployeeMutationVariables,
  ReviewerOfEmployeesInput,
} from '../../../types'
import { GraphQLFormattedError } from 'graphql'

const createReviewerOfEmployeeRelation = async (
  revEmpInput: ReviewerOfEmployeesInput,
  buId?: string,
): Promise<{
  data: CreateReviewerOfEmployeeMutation | null | undefined
  errors: readonly GraphQLFormattedError[] | undefined
}> => {
  const refetchQueries = !!buId
    ? [
        {
          query: REVIEWERS_OF_BU,
          variables: {
            buId: buId,
          },
        },
      ]
    : [
        {
          query: REVIEWERS_OF_COMPANY,
          variables: {
            companyId: revEmpInput.companyId,
          },
        },
      ]
  const { data, errors } = await client.mutate<CreateReviewerOfEmployeeMutation, CreateReviewerOfEmployeeMutationVariables>({
    mutation: CREATE_REVIEWER_OF_EMPLOYEE_RELATION,
    variables: {
      revEmpInput,
    },
    refetchQueries,
    awaitRefetchQueries: true,
  })
  return { data, errors }
}

const deleteReviewerOfEmployeeRelation = async (
  relationId: number,
  companyId?: string,
  buId?: string,
): Promise<{
  data: DeleteReviewerOfEmployeeMutation | null | undefined
  errors: readonly GraphQLFormattedError[] | undefined
}> => {
  const refetchQueries = !!buId
    ? [
        {
          query: REVIEWERS_OF_BU,
          variables: {
            buId: buId,
          },
        },
      ]
    : !!companyId
    ? [
        {
          query: REVIEWERS_OF_COMPANY,
          variables: {
            companyId: companyId,
          },
        },
      ]
    : []

  const { data, errors } = await client.mutate<DeleteReviewerOfEmployeeMutation, DeleteReviewerOfEmployeeMutationVariables>({
    mutation: DELETE_REVIEWER_OF_EMPLOYEE_RELATION,
    variables: {
      relationId,
    },
    refetchQueries,
    awaitRefetchQueries: true,
  })
  return { data, errors }
}

export { createReviewerOfEmployeeRelation, deleteReviewerOfEmployeeRelation }
